import { mapGetters, mapState } from 'vuex'
import { timestamp } from '@/utils'

export default {
  computed: {
    ...mapGetters( ['userInfos'] ),
    ...mapState({
      riskFullScreen: state => state.app.riskFullScreen
    }),
    panelHeight () {
      if (this.riskFullScreen) return 'calc(100vh - 20px)'
      let flag = this.panel.subMenu && this.panel.subMenu.length > 0 ? 120 : 80
      return this.panel.options.height - flag
    },
    panelWidth () {
      if (this.riskFullScreen) return 'calc(100vw - 25px)'
      return (this.panel.options.width - 20) + 'px'
    },
    parentPanelHeight () {
      if (this.riskFullScreen) return 'calc(100vh - 20px)'
      let flag = this.parentPanel.subMenu && this.parentPanel.subMenu.length > 0 ? 120 : 80
      return this.parentPanel.options.height - flag
    },
    parentPanelWidth () {
      if (this.riskFullScreen) return 'calc(100vw - 25px)'
      return (this.parentPanel.options.width - 20) + 'px'
    }
  },
  methods: {
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'even-row';
      } else {
        return 'even-row';
      }
    },
    onExportExcel: function (sheetOnly, exportExcel = '', exportExcelFilePrefix = '', panelId = '') {
      if (sheetOnly === false && this.downloadLoading === true) return null

      this.downloadLoading = true

      let activeName = null
      let filePrefix = null

      if (exportExcel === '') {
        activeName = this.panel.exportExcel
      }
      else {
        activeName = exportExcel
      }
      if (exportExcelFilePrefix === '')
        filePrefix = this.panel.exportExcelFilePrefix
      else
        filePrefix = exportExcelFilePrefix

      let cond = {
        customerOrderId: this.userInfos.netId,
        functionId: 'export',
        sorting: activeName,
        sheetOnly: sheetOnly
      } 
      return this.getExportExcel(cond, activeName, filePrefix, panelId).then((ret) => {
        this.downloadLoading = false
        return ret
      })
    },
    getExportExcel (cond, activeName, filePrefix, panelId) {
      return this.$tango.exportExcel(cond).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : Export Excel')
        } else {
          let sorting = rep.sorting
          let dataList = null
          if (rep.exportList && rep.exportList.length) {
            dataList  = (() => {
              if (activeName === 'TopPosition' || activeName === 'TopLong' || activeName === 'TopShort'
              || activeName === 'TopWinning' || activeName === 'TopLoosing' || activeName === 'Hedging')
                return this.isSymbolGrpKey ? rep.exportList[0].instrumentList : rep.exportList[0].currencyList
              else if (activeName === 'TopWinningClient' || activeName === 'TopLoosingClient' || activeName === 'TopActiveClient' || activeName === 'MonitoringClient' || activeName === 'MarginCall' || activeName === 'CreditControl')
                return rep.exportList[0].clientList
              else if (activeName === 'BookSummary' || activeName === 'BookPnL' || activeName === 'BookPnL1' || activeName === 'BookPnL2' || activeName === 'STPPnL' || activeName === 'Flow' || activeName === 'BookAggregation' || activeName === 'Reconciliation')
                return rep.exportList[0].instrumentList
              else if (activeName === 'TopWorkingOrder')
                return rep.exportList[0].orderList
              else if (activeName === 'ProfitAndLoss')
                return rep.exportList[0].currencyList
              else if (activeName === 'BookDiscrepancies' || activeName === 'RiskSplit')
                return rep.exportList
              else if (activeName === 'NTPLP')
                return rep.exportList[0].bookList
              else if (activeName === 'PnL Report' && panelId === 'BookPnLReport')
                return rep.exportList[0].bookList
              else if (activeName === 'PnL Report' && panelId === 'TopExposurePnLReport')
                return rep.exportList[0].instrumentList
              else
                return null
            })();
          }
          else if (activeName === 'topDetail' || activeName === 'bottomDetail') {
            dataList = rep.dossierList || rep.positionList || rep.instrumentList
          }
          if (sorting === activeName && dataList && dataList.length) {
            return this.handleDownload(dataList, cond.sheetOnly, activeName,filePrefix, panelId)
          }
        }
      }).catch(err => {
        this.$message({
          message: err,
          type: 'error'
        })
      })
    },
    handleDownload (dataList, sheetOnly, activeName,filePrefix, panelId) {
      return import('@/vendor/Export2Excel').then(excel => {
        const tHeader = (() => {
          if (activeName === 'TopPosition' || activeName === 'TopLong' || activeName === 'TopShort')
            return this.isSymbolGrpKey ? ['Instrument', 'Exposure', 'P&L', 'VWAP', 'Current'] : ['Currency', 'Exposure', 'P&L']
          else if (activeName === 'TopWinning' || activeName === 'TopLoosing')
            return this.isSymbolGrpKey ? ['Instrument', 'P&L','VWAP','Current'] : ['Currency', 'P&L']
          else if (activeName === 'TopWinningClient' || activeName === 'TopLoosingClient' || activeName === 'TopActiveClient' || activeName === 'MonitoringClient')
            return ['Env', 'Book', 'Client', 'Account','Exposure','P&L','Equity','Used Margin','Volume','Ticket Count']
          else if (activeName === 'Hedging')
            return this.isSymbolGrpKey ? ['Instrument', 'Exposure', 'Hedged Amt', 'Net Amt','P&L', 'Hedge P&L', 'Net P&L'] : ['Ccy', 'Exposure', 'Hedged Amt', 'Net Amt','P&L', 'Hedge P&L', 'Net P&L']
          else if (activeName === 'BookSummary')
            return ['Asset', 'P&L','Exposure']
          else if (activeName === 'TopWorkingOrder')
            return ['Env', 'Client', 'Account','Instrument', 'Order Side', 'Order Type', 'Price', 'Working Amt']
          else if (activeName === 'MarginCall')
            return ['Env', 'Client', 'Account', 'Equity', 'Margin Level']
          else if (activeName === 'Flow')
            return ['Instrument', 'Swap Long', 'Swap Short', 'Net Swap', 'Commission']
          else if (activeName === 'MarginCall')
            return ['Env', 'Client', 'Account', 'Equity', 'Margin Level']
          else if (activeName === 'CreditControl')
            return ['Env', 'Client', 'Account', 'Credit', 'Free Margin', 'Margin Level', 'Available']
          else if (activeName === 'Reconciliation')
            return ['Instrument', 'SE LPs', 'SE STP', 'SE Discrepancy', 'CY LPs', 'CY STP', 'CY Discrepancy']
          else if (activeName === 'NTPLP')
            return ['Env', 'Account', 'Eq to Eq', 'Volume', 'Vol Cost', 'NTP %', 'Profit Share']
          else if (activeName === 'PnL Report' && panelId === 'BookPnLReport')
            return ['Book', 'Day PL', 'Week PL', 'Month PL']
          else if (activeName === 'PnL Report' && panelId === 'TopExposurePnLReport')
            return ['Top 5 Exposure', 'Volume USD', 'Volume Lot', 'Long', 'Short', 'EOD', 'Current']
          else
            return null
        })();

        const filterVal = (() => {
          if (activeName === 'TopPosition' || activeName === 'TopLong' || activeName === 'TopShort')
            return this.isSymbolGrpKey ? ['instrumentName', 'exposure', 'profitAndLoss', 'vwap','best'] : ['currency', 'exposure', 'profitAndLoss']
          else if (activeName === 'TopWinning' || activeName === 'TopLoosing')
            return this.isSymbolGrpKey ? ['instrumentName', 'profitAndLoss','vwap','best'] : ['currency', 'profitAndLoss']
          else if (activeName === 'TopWinningClient' || activeName === 'TopLoosingClient' || activeName === 'TopActiveClient' || activeName === 'MonitoringClient')
            return ['brokerName', 'bookName', 'accountName', 'accountNumber','exposure', 'profitAndLoss', 'AccountEquity', 'usedMarginPerc', 'volume', 'ticketCount']
          else if (activeName === 'Hedging')
            return this.isSymbolGrpKey ? ['instrumentName', 'exposure','hedgedAmount','deltaHedge', 'profitAndLoss', 'profitLost', 'delta'] : ['currency', 'exposure','hedgedAmount','deltaHedge', 'profitAndLoss', 'profitLost', 'delta']
          else if (activeName === 'BookSummary')
            return ['instrumentName', 'profitAndLoss','exposure']
          else if (activeName === 'TopWorkingOrder')
            return ['brokerName', 'accountName', 'accountNumber', 'instrumentName', 'orderSide', 'orderType', 'rate', 'workingAmount']
          else if (activeName === 'MarginCall')
            return ['brokerName', 'accountName', 'accountNumber', 'AccountEquity', 'usedMarginPerc']
          else if (activeName === 'Flow')
            return ['instrumentName', 'financingLong', 'financingShort', 'rollOver', 'commission']
          else if (activeName === 'CreditControl')
            return ['brokerName', 'accountName', 'accountNumber', 'creditLine', 'FreeMargin', 'usedMarginPerc', 'availableMargin']
          else if (activeName === 'Reconciliation')
            return ['instrumentName', 'exposure1', 'exposure2', 'delta1', 'exposure3', 'exposure4', 'delta2']
          else if (activeName === 'NTPLP')
            return ['brokerName', 'accountNumber', 'profitAndLoss', 'volume', 'cost', 'pct', 'profitShare']
          else if (activeName === 'PnL Report' && panelId === 'BookPnLReport')
            return ['title', 'day', 'week', 'month']
          else if (activeName === 'PnL Report' && panelId === 'TopExposurePnLReport')
            return ['instrumentName', 'volume', 'numberOfLot', 'volumeLong', 'volumeShort', 'rollOver', 'best']
          else
            return null
        })();

        const list = dataList
        const data = this.formatJson(filterVal, list)

        if (sheetOnly) {
          return {
            data: data,
            header: tHeader,
            sheetName: filePrefix
          }
        }

        let filename = filePrefix + '_' +  timestamp()
        excel.export_json_to_excel_lusis({
          header: tHeader,
          data: data,
          filename: filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
          sheetName: filePrefix
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
        /*
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
        */
      }))
    },
    sortFloat: function(a,b,fieldName){
      let numA = 0
      if (a!==null && a!==undefined && a.hasOwnProperty(fieldName))
        numA = parseFloat(a[fieldName])
      let numB = 0
      if (b!==null && b!==undefined && b.hasOwnProperty(fieldName))
        numB = parseFloat(b[fieldName])
      if (numA>numB)
        return 1
      else if (numA<numB)
        return  -1
      return 0
    },
  },
  data: function () {
    return {
      downloadLoading: false
    }
  }
}
